import { faUser } from "@fortawesome/pro-regular-svg-icons/faUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const UserIcon: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faUser} {...props} />;
};
